define('modules/editor/models/elements/form_button',['require','exports','module','./base'],function(require, exports, module){
  "use strict";

  var Element = require("./base");

  var FormButton = module.exports = Element.extend({
    initialize: function(attrs, options) {
      module.exports.__super__.initialize.apply(this, arguments);
      if (options.rect) {
        this.setPosition({
          x: options.rect.x,
          y: options.rect.y + options.rect.height
        });
      }
      if(options.formModel){
        this.formModel = options.formModel;
      }
      //listen to this model's height/width changes so we can
      //forward it to the parent form property group
      this.listenTo(this._propertyVent, "change:height change:width", this.forwardPropsToForm);
    },
    name: "element:form:button",
    defaultPropertyGroups: [],
    defaultNameKey:"formButton",
    propertyGroups: [
      { name: "geometry",
        defaults: {
          top: 150, left: 0
        }
      },
      { name: "idclass",
        defaults: {id: "", className: ""}
      },
      { name: "form:submitFormat",
        defaults: {
          height: 60,
          width: 300
        }
      },
      {
        name: "button:style",
        defaults: {}
      }
    ],
    setGeometryProp: function(formSubmitFormat){
      this.formSubmitFormat = formSubmitFormat;
    },
    setFormModel: function(formModel){
      this.formModel = formModel;
      this.listenTo(this.formModel, 'change:displayOrder', function(model, displayOrder) {
        this.set('displayOrder', displayOrder);
      });
    },
    //override base element setSize
    setSize: function(size, options){
      var submitFormat = this.getPropertyGroup("form:submitFormat");

      submitFormat.set({
        width: parseInt(Math.max(size.width, 5)),
        height: parseInt(Math.max(size.height, 10))
      }, options);

    },
    getSize: function(){
      var submitFormat = this.getPropertyGroup("form:submitFormat");
      return {
        width: +submitFormat.get("width"),
        height: +submitFormat.get("height")
      };
    },
    forwardPropsToForm: function(){
      // console.log('FButton height/width changed');
      if(!this.formModel) { return; }
      this.formModel.updateFormButtonSize({
        width: this.getPropertyGroup("form:submitFormat").get("width"),
        height: this.getPropertyGroup("form:submitFormat").get("height"),
      });
    },
    silentlyUpdateButtonProperties: function(submitButtonProps, buttonStyleProps) {
      this._notify = false;
      this.updateButtonProperties(submitButtonProps, buttonStyleProps);
      this._notify = true;
    },
    updateButtonProperties: function(submitButtonProps, buttonStyleProps) {
      var submitProps = this.getPropertyGroup("form:submitFormat"),
          buttonProps = this.getPropertyGroup("button:style"),
          submitJSON = submitButtonProps.toJSON(),
          btnJSON = buttonStyleProps.toJSON();
      // don't want to re-trigger nothing in the prop_group renderer.
      // submitJSON.align = "left";
      // console.log('Update button props', submitJSON, btnJSON);
      submitProps.set(submitJSON);
      buttonProps.set(btnJSON);
    }
  });
});

